import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  stepper: {
    width: '100%',
    maxWidth: 600,
    margin: '21.5vh 0 3px',
    padding: '24px 2px 24px',
    background: 'transparent'
  }
})

export default useStyles